<template>
  <ContactUsComponent
    :is-visible="showContactModal"
    @close="closeContactModal"
  />
  <div class="wrapper-product">
    <MenuComponent
      logoUrl="assets/logos/LogoGreen.svg"
      textColor="var(--green)"
      menuIcon="assets/icons/MenuGreen.svg"
      closeIcon="assets/icons/CloseGreen.svg"
    />

    <PrincipalSection
      title="FOTOGRAFÍA DE PRODUCTO"
      text="Fotografía pensada para convertir y escalar en e-commerce, marketplaces y retail digital"
      overlayColor="var(--green)"
      layout="media-right"
      mediaType="image"
      mediaSrc="assets/product/InitialImage.png"
      mediaAlt="Fotografía de producto"
      buttonText="Agenda una llamada"
      buttonBackground="var(--white)"
      buttonTextColor="var(--green)"
      buttonShadow="light"
      @button-click="openContactModal"
    />

    <div class="section-container">
      <div class="media-container">
        <img
          class="section-media"
          src="assets/product/Image1.png"
          alt="Fotografía y video publicitario"
        />
      </div>

      <div class="content-container">
        <p class="section-title">Fotografía y video <b>PUBLICITARIO</b></p>

        <p class="section-text">
          Posicionamos tu marca y activamos la intención de compra en cada
          campaña
        </p>

        <GenericButton
          text="Ver galería"
          backgroundColor="var(--green)"
          textColor="var(--white)"
          shadowType="dark"
          @click="goToPublicityGallery"
        />
      </div>
    </div>

    <div class="section-container reverse">
      <div class="content-container">
        <p class="section-title">Fotografía y video <b>ECOMMMERCE</b></p>

        <p class="section-text">
          Facilitamos decisiones rápidas en entornos de venta digital
        </p>

        <GenericButton
          text="Ver galería"
          backgroundColor="var(--green)"
          textColor="var(--white)"
          shadowType="dark"
          @click="goToEcommerceGallery"
        />
      </div>

      <div class="media-container">
        <img
          class="section-media"
          src="assets/product/Image2.png"
          alt="Fotografía y video ecommerce"
        />
      </div>
    </div>

    <FooterComponent overlayColor="var(--green)" />
  </div>
</template>

<script>
import MenuComponent from "@/ux/layout/components/MenuComponent.vue";
import GenericButton from "../../components/commons/controls/GenericButton.vue";
import PrincipalSection from "../layout/components/PrincipalSection.vue";
import FooterComponent from "@/ux/layout/components/FooterComponent.vue";
import { productUse } from "../product/use/productUse";
import ContactUsComponent from "../sharedComponents/ContactUsComponent.vue";
import { contactUsUse } from "../sharedComponents/use/contactUsUse";

export default {
  name: "ProductView",
  components: {
    MenuComponent,
    PrincipalSection,
    GenericButton,
    FooterComponent,
    ContactUsComponent,
  },

  setup() {
    const { goToPublicityGallery, goToEcommerceGallery } = productUse();

    const { showContactModal, openContactModal, closeContactModal } =
      contactUsUse();

    return {
      goToPublicityGallery,
      goToEcommerceGallery,
      showContactModal,
      openContactModal,
      closeContactModal,
    };
  },
};
</script>

<style scoped lang="scss">
@import "src/ux/product/styles/productStyle";
</style>
